import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faTriangleExclamation, faCircleExclamation, faClock, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { Router } from '@angular/router';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';

@Component({
  selector: 'app-risks-alerts',
  templateUrl: './risks-alerts.component.html',
  styleUrls: ['./risks-alerts.component.scss'],
  standalone: false
})
export class RisksAlertsComponent implements OnChanges {
  protected readonly faTriangleExclamation = faTriangleExclamation;
  protected readonly faCircleExclamation = faCircleExclamation;
  protected readonly faClock = faClock;
  protected readonly faChevronRight = faChevronRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  lowStockList: any[] = [];
  deadStockList: any[] = [
    { title: 'Goodyear Wrangler AT/S 235/65R17', details: '74 days 32K tied up', actionText: 'Offer discount', },
    { title: 'MRF ZLX Sport 245/45R18', details: '61 days 24.5K tied up', actionText: 'Offer discount', },
    { title: 'JK Tyre Ultima NXT 165/80R14', details: '58 days 19.2K tied up', actionText: 'Review price', }
  ];

  lowPage: number = 0;
  lowStockCount: number = 0
  loader: boolean = false;
  errMsg: string = '';
  lowScroolLoader: boolean = false;
  endOfLowResults: boolean = false;

  deadPage: number = 0;
  deadStockCount: number = 0
  deadLoader: boolean = false;
  deadErrMsg: string = '';
  deadScroolLoader: boolean = false;
  endOfDeadResult: boolean = false;


  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
    private readonly ledgersService: LedgersService,
    private readonly router: Router,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.loader = true
      this.endOfLowResults = false
      this.lowStockList = [];
      this.lowPage = 0;
      this.getData();
    }
  }

  getData() {
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate,
      page: this.lowPage,
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getLowStock(params).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.lowScroolLoader = false;
        if (res.data) {
          this.lowStockCount = this.cmnService.parseNumberOrZero(res.data?.count)
          const result = res.data?.result || [];
          if (result.length == 0) {
            this.endOfLowResults = true;
          }
          this.mapResponse(result)
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.lowScroolLoader = false;
        this.errMsg = err?.error?.error?.message || "Failed to fetch response"
      }
    })
  }

  mapResponse(data: any) {
    if (!Array.isArray(data)) return;
    let tableData = data.map((item: any) => {
      item.actionText = (item.closingBalance < 3) ? 'Reorder now' : 'Reorder soon';
      return {
        ...item,
        title: `${item.tyreMake || ''} ${item.tyreModel || ''} ${item.tyreSize || ''}`,
        details: `${this.cmnService.parseNumberOrZero(item.closingBalance)} in stock Min ${item.reorderThreshold ?? 5}`
      };
    });
    this.lowStockList = [...this.lowStockList, ...tableData];
  }

  viewAllLowStock(content: any) {
    this.modalService.open(content, { size: 'lg', centered: true, scrollable: true });
  }

  onLowScroll() {
    if (this.endOfLowResults || this.lowScroolLoader || this.loader) return;
    this.lowPage++;
    this.getData();
  }

  onRowClick(item: any) {
    this.modalService.dismissAll();
    if (this.selectedDate) {
      this.dayBookService.setSavedDayBookDate({
        currentDate: this.selectedDate,
        selectedBranchId: this.selectedBranch
      });
    }
    this.ledgersService.selectedSkuFilter = {
      tyreMake: item.tyreMake || '',
      tyreModel: item.tyreModel || '',
      tyreSize: item.tyreSize || '',
      company: item.companyId || '',
    };
    this.router.navigate(['/sku-ledger']);
  }

}
